<template>
  <div id="TitlePage">
    <img class="title" :src="require(`./img/a${id}.png`)" alt="title">
    <img class="photo" :src="require(`./img/a${id}-1.png`)" alt="photo">
    <div class="btn-wrap">
      <img v-show="btnVisiable" :src="require(`./img/btn.png`)" alt="button" @click="$router.push(`/Part${id}`)">
    </div>
  </div>
</template>

<script>
export default {
  name: 'TitlePage',
  data () {
    return {
      btnVisiable: true,
    }
  },
  computed: {
    id () {
      return this.$route.params.id
    },
    narrate () {
      const map = {
        '01': '03',
        '02': '16',
        '03': '18',
        '04': '19',
        '05': '20',
      }
      return map[this.id]
    },
  },
  watch: {
    id: {
      handler () {
        this.$narrate.play(this.narrate, { auto: true })
      },
      immediate: true,
    },
  },
  beforeDestroy () {
    this.$narrate.pause()
  },
}
</script>

<style lang="scss" scoped>
#TitlePage {
  text-align: center;
  background-image: url('./img/bg.jpg');
  background-size: cover;
  .title {
    width: 10.1rem;
    height: 1.4rem;
    margin-top: 1.8rem;
    margin-bottom: 0.4rem;
  }
  .photo {
    width: 12.3rem;
    height: 5.7rem;
    border-radius: 0.2rem;
  }
  .btn-wrap {
    position: relative;
    top: -2rem;
    width: 3.8rem;
    height: 1.2rem;
    margin: 0 auto;
    & > img {
      width: 100%;
      height: 100%;
      cursor: pointer;
    }
  }
}
</style>
